import React, { useState } from 'react';
import { Modal, Button, ModalFooter, ModalBody } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import * as Icon from 'react-feather';

import Timer from '../../utils/Timer';

import {
  onSetCallStatus,
  onSetCallType,
  setBreakDetails,
  setCallDialSec,
  setCallEnd,
  setCallId,
  setSelectBreakType,
  useBreakDetails
} from '../../store/slices/dialSlice';
import { selectBreak, setIdleCall } from '../../store/slices/callingSlice';
import { setCallingModalOpen, setSidebarType } from '../../store/slices/commonSlice';
import { useUserDetails } from '../../store/slices/authSlice';
import { useTranslation } from 'react-i18next';
import { useCallingData } from '../Context/CallingContext';

const BreakModal = () => {
  const navigate = useNavigate();
  const user = useUserDetails();
  const { t } = useTranslation();
  const { handleTimeReset } = useCallingData();

  const [duration, setDuration] = useState(0);

  const dispatch = useDispatch();

  const breakDetails = useBreakDetails();

  const onIdleSet = async () => {
    try {
      await dispatch(setIdleCall()).unwrap();
      dispatch(setCallId(null));
      dispatch(setCallingModalOpen(user?.manualcall ? true : false));
      dispatch(setCallDialSec(null));
      dispatch(setSidebarType('main'));
      dispatch(setCallEnd(false));
      handleTimeReset();
      dispatch(onSetCallStatus(null));
      dispatch(onSetCallType(null));
      navigate('/dashboard');
    } catch (error) {
      console.log('error', error);
    }
  };

  const onReadyClick = async () => {
    try {
      const payload = { ...breakDetails, type: 'out' };
      await dispatch(selectBreak(payload)).unwrap();
      onIdleSet();
      dispatch(setBreakDetails(null));
      dispatch(setSelectBreakType(null));
      handleTimeReset();
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <Modal isOpen={true} size="md" centered backdrop>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4">
          <Icon.Coffee size={60} className="text-info" />
          <div className="fs-4 pt-3">{breakDetails?.break_name}</div>
          <div className="fs-6 pt-2 text-primary">
            <Timer duration={duration} setDuration={setDuration} />
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="py-2 d-flex justify-content-center">
        <Button className="px-5 py-2 bg-primary border-primary" onClick={onReadyClick}>
          {t('ready')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default BreakModal;
